import { render, staticRenderFns } from "./ChapterPopup.vue?vue&type=template&id=e606c460&scoped=true&"
import script from "./ChapterPopup.vue?vue&type=script&lang=js&"
export * from "./ChapterPopup.vue?vue&type=script&lang=js&"
import style0 from "./ChapterPopup.vue?vue&type=style&index=0&id=e606c460&prod&lang=scss&"
import style1 from "./ChapterPopup.vue?vue&type=style&index=1&id=e606c460&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e606c460",
  null
  
)

export default component.exports